/****************************************************************************************
 * File Name    : SheetPatrol.vue
 * Function     :
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  :
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-space style="margin-bottom: 10px;">
            <a-radio-group v-model="filterState" @change="onChangeFilterState">
                <a-radio-button value="V">작성완료</a-radio-button>
                <a-radio-button value="X">승인완료</a-radio-button>
                <a-radio-button value="V,X">모두보기</a-radio-button>
            </a-radio-group>
        </a-space>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title = "점검일지 관리" />
                </div>
            </a-col>
        </a-row>
        <a-divider type = 'horizontal' />
        <a-form class="" layout = "vertical" >
            <a-card>
                <a-row>
                    <a-col :span="16">
                        <a-space align="end">
                            일지 조회
                            <a-input default-value="" v-model="filterCS">	
                                <a-select slot="addonAfter" default-value="제목" v-model="filterField">	
                                    <a-select-option value="관리구분">관리구분</a-select-option>
                                    <a-select-option value="제목">제목</a-select-option>	
                                    <a-select-option value="대상">대상</a-select-option>
                                    <a-select-option value="결과">결과</a-select-option>
                                    <!-- <a-select-option value="작성일자">작성일자</a-select-option>	
                                    <a-select-option value="작성상태">작성상태</a-select-option> -->	
                                </a-select>	
                            </a-input>

                            일자 조회
                            <date-picker v-model="filterDateStartCS" valueType="format" format="YYYY-MM-DD" style="width:120px;"></date-picker> ~
                            <date-picker v-model="filterDateEndCS" valueType="format" format="YYYY-MM-DD" style="width:120px;"></date-picker>
                            
                            <a-button type="primary" ghost="true" @click="filterCSList">검색</a-button>
                            <a-button @click="resetCSList">초기화</a-button>
                        </a-space>
                    </a-col>
                    <a-col :span="8">
                        <a-space style="float:right;">
                            <span class = 'icon_button' @click="excelDownload()">	
                                <a-tag color="#28A745" style="cursor:pointer;">	
                                    <a-icon type="download" /> 엑셀 다운로드	
                                </a-tag>	
                            </span>
                        </a-space>
                    </a-col>
                </a-row>
                <p/>
                <a-table :columns="columns3" size = "small" :bordered=false :data-source="data3" :pagination="pagination" :scroll="{ x: 0, y: '80vh' }" @change="handleTableChange">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ green: (tag === '작성완료'), navy: (tag === '승인완료') }">
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="action" slot-scope="record">
                        <span style = 'cursor:pointer' @click="handlerToViewProductCS(record.key, 'P')"><a-icon type="eye" /> View</span>	
                        <a-divider type="vertical" />	
                        <span style = 'cursor:pointer' @click="handlerToDeleteProductCS(record.key, 'P')"><a-icon type="delete" /> Delete</span>
                    </span>
                </a-table>
            </a-card>

        </a-form>
        <a-drawer title="" placement="right" :closable="false" :visible="flagForDrawer" @close="handlerForCloseDrawer" width="100%" >
            <SafetyReportViewer :target = "target" :pop = "pop" :showSaveBtn = true :showConfirmBtn = true v-on:flagForDrawer="handlerForCloseDrawer" v-on:editSafetyCS="handlerToEditSafetyCS" />
        </a-drawer>
    </div>
</template>
<script>
import _ from "lodash";
import DatePicker from 'vue2-datepicker';
import ExcelJS from "exceljs/dist/exceljs";
import PageHeader from "../components/PageHeader.vue";
import SafetyReportViewer from "./SafetyReportViewer.vue" ;

const userAgent = navigator.userAgent.toLowerCase();
const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|samsungbrowser|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

const columns = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '모델명' , dataIndex: 'model' , key: 'model' , scopedSlots: { customRender: 'model' },},
    {    title: '세부모델명' , dataIndex: 'modelDetail' , key: 'modelDetail' , scopedSlots: { customRender: 'modelDetail' },},
    {    title: '제품명' , dataIndex: 'product' , key: 'product' , scopedSlots: { customRender: 'name' },},
    {    title: 'POP' , dataIndex: 'pop' , key: 'pop' , scopedSlots: { customRender: 'pop' },},
    {    title: '라인' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'name' },},
    {    title: '최종수정일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     },},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 250},
];
const columns2 = [
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 100},	
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},	
    {    title: '이름'    ,   dataIndex: 'name' ,   key: 'name'     ,  scopedSlots: { customRender: 'name'        },},
];
let columns3 = [
    {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
    {    title: '관리구분' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 150},
    {    title: '제목' , dataIndex: 'title' , key: 'title' , scopedSlots: { customRender: 'title' }, width : 350},
    {    title: '대상' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 150},
    {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'updated'     }, width : 80},
    {    title: '등록일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 150},
    {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 200},
];
if (isTablet) {
    columns3 = [
        {    title: '상태'    ,   dataIndex: 'tags' ,   key: 'tags'     ,  scopedSlots: { customRender: 'tags'        },  width : 100},
        {    title: '관리구분' , dataIndex: 'category' , key: 'category' , scopedSlots: { customRender: 'category' }, width : 150},
        {    title: '제목' , dataIndex: 'title' , key: 'title' , scopedSlots: { customRender: 'title' }, width : 350},
        {    title: '대상' , dataIndex: 'line' , key: 'line' , scopedSlots: { customRender: 'line' }, width : 150},
        {    title: '결과',  dataIndex: 'checkState', key: 'checkState'  ,  scopedSlots: { customRender: 'updated'     }, width : 80},
        {    title: '등록일',  dataIndex: 'updated', key: 'updated'  ,  scopedSlots: { customRender: 'updated'     }, width : 150},
        {    title: '관리'                          ,   key: 'action'   ,  scopedSlots: { customRender: 'action'      },  width : 80},
    ];
}

const data = [
  {    key: '1',    name: 'FGCS210505-WP400-V1 보류중 20200401-15:30'   ,  tags: ['필요'],  },
  {    key: '2',    name: 'FGCS210505-WP301-V1 보류중 20200329-09:30'   ,  tags: ['필요'],  },
  {    key: '3',    name: 'PCCS210505-WP400-V1 완료 20200401-15:30'     ,  tags: ['진행'],  },
  {    key: '4',    name: 'PCCS210505-WP301-V1 완료 20200329-09:30'     ,  tags: ['완료'],  },
];

export default {
    name: 'SafetyReport',
    components: {
        PageHeader ,
        DatePicker,
        SafetyReportViewer,
    },
    data() {
        return {
            isDataLoaded : false,
            flagForDrawer: false,
            data,
            columns,
            columns2,
            columns3,
            data3: [],
            data3Backup: [],	
            dataArray3: [],	
            pop: null,	
            target: null,	
            filterCS : '',	
            filterField: '관리구분',
            filterDateStartCS: '',
            filterDateEndCS: '',
            filterState: 'V,X',
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            }
        };
    },
    mounted() {
        this.pop = sessionStorage.getItem('safety_pop') || '';
        
        this.isDataLoaded = true;
        this.fetchProductCSList();

        if (isTablet) {
            let x;
            let els1 = document.body.querySelectorAll('.ant-layout-header');
            for (x = 0; x < els1.length; x++) {
                els1[x].style.display = 'none';
            }
            let els2 = document.body.querySelectorAll('.ant-breadcrumb');
            for (x = 0; x < els2.length; x++) {
                els2[x].style.display = 'none';
            }
            let els3 = document.body.querySelectorAll('.ant-divider-horizontal');
            for (x = 0; x < els3.length; x++) {
                els3[x].style.display = 'none';
            }
            let els4 = document.body.querySelectorAll('.desktop-only');
            for (x = 0; x < els4.length; x++) {
                els4[x].style.display = 'none';
            }
            let els5 = document.body.querySelectorAll('.ant-layout-sider');
            for (x = 0; x < els5.length; x++) {
                els5[x].style.display = 'none';
            }
        }
    },
    methods : {
        fetchProductCSList(skipBarcodeScan, page = 1, pageSize = 10) {
            this.dataArray3 = [];
            this.data = [];
            this.data3 = [];
            this.flagSpinner = true;
            
            // 기존 페이징 방식으로 복원 (서버에서 정렬 처리)
            let urlToFetchProductCSList = `${this.$store.state.nodeApiUrl}/product/cs/list_safety?size=${pageSize}&page=${page-1}&state=${this.filterState}`;
            
            if (this.filterCS) {
                if (this.filterField === '제목') {
                    urlToFetchProductCSList += `&title=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '대상') {
                    urlToFetchProductCSList += `&line=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '결과') {
                    urlToFetchProductCSList += `&cs_time=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '관리구분') {
                    urlToFetchProductCSList += `&category=${encodeURIComponent(this.filterCS)}`;
                }
            }
            
            if (this.filterDateStartCS) {
                urlToFetchProductCSList += `&start_date=${this.filterDateStartCS}`;
            }
            if (this.filterDateEndCS) {
                urlToFetchProductCSList += `&end_date=${this.filterDateEndCS} 23:59:59`;
            }
            
            this.$http.get(urlToFetchProductCSList)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    // 서버에서 이미 정렬된 데이터 사용
                    const pageData = response.data.data.content;
                    
                    // 페이지네이션 정보 업데이트
                    this.pagination.total = response.data.data.totalElements;
                    this.pagination.current = page;
                    this.pagination.pageSize = pageSize;
                    
                    this.dataArray3 = pageData;
                    
                    // 데이터 처리
                    this.processData();
                }
                this.flagSpinner = false;
            }).catch(error => {
                console.log(error);
                this.flagSpinner = false;
            });
        },
        
        processData() {
            _.forEach(this.dataArray3, function(item) {
                _.forEach(item.listProductCSInpection, function(item2) {
                    if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                        for (var i = 0; i < 14; i++) {
                            item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                        }
                    } else if (item2.listProductCSInpectionStandard.length === 1) {
                        let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                            max = item2.listProductCSInpectionStandard[0].max.split('||'),
                            name = item2.listProductCSInpectionStandard[0].name.split('||'),
                            result = item2.listProductCSInpectionStandard[0].result.split('||'),
                            obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                        for (var j = 0; j < 15; j++) {
                            obj.min = min[j];
                            obj.max = max[j];
                            obj.name = name[j];
                            obj.result = result[j];
                            item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                        }
                    }
                })
            });
            
            // 정렬은 이미 fetchProductCSList에서 처리됨
            
            let data3 = [];
            
            for(let x = 0; x < this.dataArray3.length ; x ++) {
                let updatedObj = new Date((new Date(this.dataArray3[x].updated)).getTime() + 0 * 60 * 60 * 1000);
                let year = updatedObj.getFullYear();
                let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                let date = updatedObj.getDate().toString().padStart(2, '0');
                
                let checkState = '양호';
                _.forEach(this.dataArray3[x].listProductCSInpection, function(item) {
                    if (item.listProductCSInpectionStandard[0].min === 'X') {
                        checkState = '불량';
                        return false;
                    } else if (item.listProductCSInpectionStandard[0].min === '△') {
                        checkState = '미흡';
                    }
                });

                data3.push({
                    key : x,
                    name : this.dataArray3[x].name,
                    pop : this.dataArray3[x].clsProduct.productPop,
                    tags : (this.dataArray3[x].state === 'V' ? ['작성완료'] : ['승인완료']),
                    updated : `${year}-${month}-${date}`,
                    model : this.dataArray3[x].clsProduct.productModel,
                    modelDetail : this.dataArray3[x].clsProduct.productModelDetail,
                    product : this.dataArray3[x].clsProduct.productName,
                    manager: this.dataArray3[x].manager,
                    line : this.dataArray3[x].line,
                    barcode : this.dataArray3[x].barcode,
                    checkState: checkState,
                    category : this.dataArray3[x].category,
                    title : this.dataArray3[x].title,
                    target : this.dataArray3[x].target,
                    image1 : this.dataArray3[x].image1,
                    image2 : this.dataArray3[x].image2,
                    productCsSeq: this.dataArray3[x].productCsSeq,
                });
            }
            
            this.data3 = data3;
            this.data3Backup = JSON.parse(JSON.stringify(this.data3));
        },
        handlerToViewProductCS(dataOffset) {
            this.dataOffset = dataOffset;
            let target = this.dataArray3[dataOffset];

            let urlToFetchProductCSList = this.$store.state.nodeApiUrl + "/product/cs/get_safety_cs_item?seq=" + target.productCsSeq;
                this.$http.get(urlToFetchProductCSList)
                .then((response) => {
                    if(response.status === 200 && response.data.code === 'success') {
                        let item = response.data.data.content[0];
                        this.target = item;

                        _.forEach(item.listProductCSInpection, function(item2) {
                            if (item2.listProductCSInpectionStandard.length === 1 && item2.listProductCSInpectionStandard[0].min === '') {
                                for (var i = 0; i < 14; i++) {
                                    item2.listProductCSInpectionStandard.push(JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0])));
                                }
                            } else if (item2.listProductCSInpectionStandard.length === 1) {
                                let min = item2.listProductCSInpectionStandard[0].min.split('||'),
                                    max = item2.listProductCSInpectionStandard[0].max.split('||'),
                                    name = item2.listProductCSInpectionStandard[0].name.split('||'),
                                    result = item2.listProductCSInpectionStandard[0].result.split('||'),
                                    obj = JSON.parse(JSON.stringify(item2.listProductCSInpectionStandard[0]));
                                for (var j = 0; j < 15; j++) {
                                    obj.min = min[j];
                                    obj.max = max[j];
                                    obj.name = name[j];
                                    obj.result = result[j];
                                    item2.listProductCSInpectionStandard[j] = JSON.parse(JSON.stringify(obj));
                                }
                            }
                        })

                        let updatedObj = new Date((new Date(this.target.updated)).getTime() + 0 * 60 * 60 * 1000);
                        let year = updatedObj.getFullYear();
                        let month = updatedObj.getMonth() + 1;
                        if (month < 10) {
                            month = '0' + month;
                        }
                        let date = updatedObj.getDate();
                        if (date < 10) {
                            date = '0' + date;
                        }
                        let hour = updatedObj.getHours();
                        if (hour < 10) {
                            hour = '0' + hour;
                        }
                        let minute = updatedObj.getMinutes();
                        if (minute < 10) {
                            minute = '0' + minute;
                        }
                        let second = updatedObj.getSeconds();
                        if (second < 10) {
                            second = '0' + second;
                        }
                        this.target.updated = year + '-' + month + '-' + date;

                        this.flagForDrawer = true;
                    }
                });
        },
        handlerToEditSafetyCS(listItem, state) {
            let generatedObjectToPersist = {
                productCsSeq: listItem.productCsSeq,
                productSeq: listItem.clsProduct.productSeq,
                productCSName: listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: state,
                pop: listItem.pop,
                csTime: listItem.csTime,
                line: listItem.line,
                barcode: listItem.barcode,
                manager: listItem.manager,
                approver: (state === 'X' ? sessionStorage.getItem('user_name') : ''),
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let min = [],
                    max = [],
                    name = [],
                    result = [];

                _.forEach(item.listProductCSInpectionStandard, function(item2) {
                    min.push(item2.min || '');
                    max.push(item2.max || '');
                    name.push(item2.name || '');
                    result.push(item2.result || '');
                });

                min = min.join('||');
                max = max.join('||');
                name = name.join('||');
                result = result.join('||');

                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: min,
                        max: max,
                        name: name,
                        result: result
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: item.inspectionImage2Seq,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/edit';
            this.$http.put(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('저장되었습니다');
                    
                    // 현재 페이지를 유지하면서 목록의 상태만 업데이트
                    this.updateItemStateInCurrentList();
                    
                    // 레이어 닫기
                    this.flagForDrawer = false;
                }  else {
                    this.$message.error('저장되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('저장되지 않았습니다(2).');
            });
        },
        
        updateItemStateInCurrentList() {
            // 상태 변경 후 전체 데이터 재정렬이 필요하므로 새로 데이터를 가져옴
            // 현재 페이지는 유지하면서 올바른 정렬된 데이터를 표시
            this.refreshCurrentPageData();
        },
        
        refreshCurrentPageData() {
            // 현재 페이지와 페이지 사이즈 유지하면서 데이터 갱신
            this.fetchProductCSList(false, this.pagination.current, this.pagination.pageSize);
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
        },
        handlerToDeleteProductCS(dataOffset) {
            this.target = this.dataArray3[dataOffset];

            if (confirm('삭제하시겠습니까?')) {
                let urlForProduct = this.$store.state.hostInService + '/product/cs/delete';
                let listItem = this.target;
                let generatedObjectToPersist = {
                    productCsSeq: listItem.productCsSeq
                };
                this.$http.put(urlForProduct,generatedObjectToPersist)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            this.$message.success('삭제되었습니다');
                            
                            // 현재 페이지와 검색 조건을 유지하면서 목록 갱신
                            this.refreshCurrentPageData();
                        }  else {
                            this.$message.error('삭제되지 않았습니다(1).');
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        this.$message.error('삭제되지 않았습니다(2).');
                    });
            }
        },
        handlerToCreateCSForSafetyPop() {
            if (!this.pop) {
                this.$message.error('POP를 입력해주세요');
                return;
            }
            
            let pop = this.pop;
            if (pop) {
                sessionStorage.setItem('safety_pop', pop);
                location.reload();
            } else {
                this.$message.error('인식된 POP의 제품이 등록되어 있지 않습니다.');
            }
        },
        handlerToCreateCSForSafety(listItem) {

            let generatedObjectToPersist = {
                productSeq: listItem.clsProduct.productSeq,
                productCSName: 'SAFETYCS-' + listItem.name,
                productCSInspections: [],
                productCSTimes: [],
                state: 'U',
                pop: this.pop,
                csTime: ''
            };

            _.forEach(listItem.listProductCSInpection, (item) => {
                let obj = {
                    index: '' + item.inspectionIndex,
                    offset: '' + item.inspectionOffset,
                    inspection: item.inspectionName,
                    inspectionTarget: item.inspectionTarget || '',
                    standard: {
                        min: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].min || '',
                        max: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].max || '',
                        name: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].name || '',
                        result: item.listProductCSInpectionStandard.length && item.listProductCSInpectionStandard[0].result || ''
                    },
                    imageSeq: item.inspectionImageSeq,
                    image2Seq: 0,
                    description: item.inspectionDescription
                };

                generatedObjectToPersist.productCSInspections.push(obj);
            });

            _.forEach(listItem.listProductCSTime, (item) => {
                let obj = {
                    start: item.timeStart,
                    terms: item.timeTerms
                };

                generatedObjectToPersist.productCSTimes.push(obj);
            });


            let urlForProduct = this.$store.state.hostInService + '/product/cs/add';
            this.$http.post(urlForProduct,generatedObjectToPersist)
            .then((response) => {
                if (response.status === 200 && response.data.code === 'success') {
                    this.$message.success('생성되었습니다');
                    this.fetchProductCSList(true, true);
                    this.pop = '';
                    sessionStorage.removeItem('safety_pop');
                }  else {
                    this.$message.error('생성되지 않았습니다(1).');
                }
            })
            .catch(error => {
                console.error(error);
                this.$message.error('생성되지 않았습니다(2).');
            });
        },
        filterCSList() {
            this.pagination.current = 1;
            this.fetchProductCSList(false, 1, this.pagination.pageSize);
            
            if (this.filterCS || this.filterDateStartCS || this.filterDateEndCS) {
                this.$message.info('검색이 완료되었습니다');
            }
            
            console.log('필터링 적용:', {
                필드: this.filterField,
                검색어: this.filterCS,
                시작일: this.filterDateStartCS,
                종료일: this.filterDateEndCS
            });
        },
        
        handleTableChange(pagination) {
            this.fetchProductCSList(false, pagination.current, pagination.pageSize);
        },
        excelDownload() {
            this.flagSpinner = true;
            
            // 현재 적용된 필터 조건으로 모든 데이터 가져오기
            let urlToFetchAllData = `${this.$store.state.nodeApiUrl}/product/cs/list_safety?size=10000&page=0&state=${this.filterState}`;
            
            // 필터 조건 추가
            if (this.filterCS) {
                if (this.filterField === '제목') {
                    urlToFetchAllData += `&title=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '대상') {
                    urlToFetchAllData += `&line=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '결과') {
                    urlToFetchAllData += `&cs_time=${encodeURIComponent(this.filterCS)}`;
                } else if (this.filterField === '관리구분') {
                    urlToFetchAllData += `&category=${encodeURIComponent(this.filterCS)}`;
                }
            }
            
            // 날짜 필터 추가
            if (this.filterDateStartCS) {
                urlToFetchAllData += `&start_date=${this.filterDateStartCS}`;
            }
            if (this.filterDateEndCS) {
                urlToFetchAllData += `&end_date=${this.filterDateEndCS} 23:59:59`;
            }
            
            this.$http.get(urlToFetchAllData)
            .then((response) => {
                if(response.status === 200 && response.data.code === 'success') {
                    let allData = response.data.data.content;
                    
                    // 데이터 정렬 (작성완료, 승인완료 순으로)
                    let tempArr1 = _.filter(allData, { state: 'V' });
                    tempArr1 = _.orderBy(tempArr1, ['updated'], ['desc']);
                    let tempArr2 = _.filter(allData, { state: 'X' });
                    tempArr2 = _.orderBy(tempArr2, ['updated'], ['desc']);
                    let sortedData = tempArr1.concat(tempArr2);
                    
                    // 엑셀 데이터 준비
                    let excelData = [];
                    
                    // 헤더 추가
                    excelData.push(['상태', '관리구분', '제목', '대상', '결과', '등록일']);
                    
                    // 데이터 행 추가
                    _.forEach(sortedData, (item) => {
                        // 상태 설정
                        let status = item.state === 'V' ? '작성완료' : '승인완료';
                        
                        // 결과 설정
                        let checkState = '양호';
                        _.forEach(item.listProductCSInpection, function(inspection) {
                            if (inspection.listProductCSInpectionStandard && inspection.listProductCSInpectionStandard[0]) {
                                if (inspection.listProductCSInpectionStandard[0].min === 'X') {
                                    checkState = '불량';
                                    return false;
                                } else if (inspection.listProductCSInpectionStandard[0].min === '△') {
                                    checkState = '미흡';
                                }
                            }
                        });
                        
                        // 날짜 포맷팅
                        let updatedObj = new Date(item.updated);
                        let year = updatedObj.getFullYear();
                        let month = (updatedObj.getMonth() + 1).toString().padStart(2, '0');
                        let date = updatedObj.getDate().toString().padStart(2, '0');
                        let formattedDate = `${year}-${month}-${date}`;
                        
                        // 행 데이터 추가
                        excelData.push([
                            status,
                            item.category || '',
                            item.title || '',
                            item.line || '',
                            checkState,
                            formattedDate
                        ]);
                    });
                    
                    // ExcelJS 워크북 생성
                    var workbook = new ExcelJS.Workbook();
                    var worksheet = workbook.addWorksheet('안전보건점검일지');
                    
                    // 데이터 추가
                    worksheet.addRows(excelData);
                    
                    // 헤더 스타일 적용
                    worksheet.getRow(1).font = { bold: true };
                    worksheet.getRow(1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFE0E0E0' }
                    };
                    
                    // 컬럼 너비 자동 조정
                    worksheet.columns.forEach((column, index) => {
                        let maxLength = 0;
                        column.eachCell({ includeEmpty: true }, (cell) => {
                            if (cell.value) {
                                const cellValue = cell.value.toString();
                                // 한글은 2배 길이로 계산 (한글이 영문보다 넓기 때문)
                                const koreanLength = (cellValue.match(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g) || []).length * 2;
                                const englishLength = cellValue.length - (cellValue.match(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g) || []).length;
                                const columnLength = koreanLength + englishLength;
                                
                                if (columnLength > maxLength) {
                                    maxLength = columnLength;
                                }
                            }
                        });
                        
                        // 컬럼별 최소 너비 설정
                        let minWidth = 10;
                        if (index === 2) { // 제목 컬럼 (index 2)
                            minWidth = 30; // 제목은 최소 30자 너비 보장
                        } else if (index === 0) { // 상태 컬럼
                            minWidth = 12;
                        } else if (index === 1) { // 관리구분 컬럼
                            minWidth = 15;
                        }
                        
                        // 최종 너비 결정 (최소값과 계산된 값 중 큰 값 + 여유공간)
                        column.width = Math.max(minWidth, maxLength + 3);
                    });
                    
                    // 파일명에 현재 날짜 추가
                    let dateObj = new Date();
                    let year = dateObj.getFullYear();
                    let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                    let date = dateObj.getDate().toString().padStart(2, '0');
                    let dateStr = year + month + date;
                    
                    // 엑셀 파일 생성 및 다운로드
                    workbook.xlsx.writeBuffer().then(function(data) {
                        var blob = new Blob([data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        var filename = '안전보건점검일지_' + dateStr + '.xlsx';
                        var reader = new FileReader();

                        reader.readAsDataURL(blob);

                        reader.onload = function(event) {
                            let save = document.createElement("a");
                            save.href = event.target.result;
                            save.download = filename;
                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);
                            window.URL.revokeObjectURL(save.href);
                        };
                    });
                    
                    this.$message.success('엑셀 파일이 다운로드되었습니다.');
                } else {
                    this.$message.error('데이터를 가져오는데 실패했습니다.');
                }
                this.flagSpinner = false;
            }).catch(error => {
                console.log(error);
                this.$message.error('엑셀 다운로드 중 오류가 발생했습니다.');
                this.flagSpinner = false;
            });
        },
        
        processExcelData(data) {
            let listData = [];
            
            let tempArr1 = _.filter(data, {
                state: 'V'
            });
            tempArr1 = _.orderBy(tempArr1, ['updated'], ['desc']);
            let tempArr2 = _.filter(data, {
                state: 'X'
            });
            tempArr2 = _.orderBy(tempArr2, ['updated'], ['desc']);
            let sortedData = tempArr1.concat(tempArr2);
            
            _.forEach(sortedData, (item) => {
                let checkState = '양호';
                if (item.csTime === '미흡') {
                    checkState = '미흡';
                }
                
                item.checkState = checkState;
                listData.push(item);
            });
            
            return listData;
        },
        resetCSList() {
            this.filterCS = '';
            this.filterField = '관리구분';
            this.filterDateStartCS = '';
            this.filterDateEndCS = '';
            this.filterState = 'V,X';
            
            this.pagination.current = 1;
            this.fetchProductCSList();
            
            this.$message.success('필터가 초기화되었습니다');
        },
        onChangeFilterState() {
            this.pagination.current = 1;
            this.fetchProductCSList(false, 1, this.pagination.pageSize);
        }
    }
}
</script>
<style scoped>
</style>